<davinci-button class="button publish" icon="editor/publish" [disabled]="!manifest.devices?.length" (click)="publish()">{{
  'manifest-detail.publish' | translate
}}</davinci-button>
